/**
 * Helper function to get config value from runtime config or build-time env
 * In production (Docker), uses runtime config injected at container startup
 * In development, uses process.env from build time
 */
export const getConfig = (key) => {
  // Try runtime config first (injected by docker-entrypoint.sh)
  if (window.RUNTIME_CONFIG && window.RUNTIME_CONFIG[key]) {
    return window.RUNTIME_CONFIG[key];
  }
  // Fallback to build-time environment variable (for local development)
  return process.env[key];
};

export default getConfig;
